import { Component } from '@angular/core';

@Component({
  selector: 'ln-english-fag-svg-icon',
  imports: [],
  templateUrl: './english-fag-svg-icon.component.html',
  styleUrl: './english-fag-svg-icon.component.css',
})
export class EnglishFagSvgIconComponent {}
